<template>
  <div
    style="min-height: calc(100vh - 160px)"
    v-loading="homeLoading"
    element-loading-text="数据处理中......"
  >
    <!-- 修改 -->
    <div v-if="singleData.statusCheck == 0">
      <finishAdd
        :itemList="itemList"
        :finish_type="1"
        :addData="singleData"
        @backOrderState="getList()"
        @backHome="backHome"
      ></finishAdd>
    </div>
    <!-- 详情 -->
    <div v-if="singleData.statusCheck == 1">
      <div class="title">
        <div class="title--newFont">
          <span>{{ $t("委外收货详情") }}</span>
        </div>
        <div style="text-align: right">
          <el-button size="mini" class="btnTwo" @click="backHome">{{
            $t("返回")
          }}</el-button>
        </div>
      </div>
      <hr />
      <!-- 内容 -->
      <div>
        <myTable
          :id="'myTableOne'"
          :columnType="'columnIndex'"
          :list="itemList"
          :titleList="itemTitleList"
          :tableBtnList="itemTableBtnList"
          @btnClick="productBtnClick"
          @inputNumberClick="inputNumberClick"
          ref="myTableOne"
        ></myTable>
      </div>
    </div>
  </div>
</template>
<script>
import {
  divFloat,
  mulFloat,
  accAdd,
  subFloat,
  year,
  month,
  day,
  _debounce,
} from "@/utils/myUtils";
import { outsourcingtowarehouse_view } from "@/api/myController/outsourcing";
import finishAdd from "@/views/outsourcingProduct/components/finish_add.vue";
export default {
  props: {
    // 页面传进来判断的值
    routeType: {
      type: Array,
      default: undefined,
    },
    // 页面传进来的值
    routeQuery: {
      default: () => ({}),
    },
    itemList: {
      type: Array,
      required: false,
      default() {
        return [];
      },
    },
    // 新增数据
    singleData: {
      default: () => ({}),
    },
  },
  components: { finishAdd },
  data() {
    return {
      btnLoading: false,
      homeLoading: false,
      // ------------------基础数据
      itemTableBtnList: [],
      itemTitleList: [
        {
          id: 1,
          name: this.$t("关联单号"),
          value: "baseOutsourcingDocNumber",
          fixedState: false,
          isShow: true,
          dataType: "text",
          selectOptionKey: "",
          selectOptionList: [],
          canEdit: false,
          width: 150,
        },
        {
          id: 1,
          name: this.$t("收货单号"),
          value: "outsourcingtowarehouseNumber",
          fixedState: false,
          isShow: true,
          dataType: "text",
          selectOptionKey: "",
          selectOptionList: [],
          alwaysEditState: false,
          canEdit: false,
          width: 150,
        },
        {
          id: 1,
          name: this.$t("全局搜索码"),
          value: "globalSearchNumber",
          fixedState: false,
          isShow: true,
          dataType: "text",
          selectOptionKey: "",
          selectOptionList: [],
          canEdit: false,
          width: 150,
        },
        {
          id: 3,
          name: this.$t("产品编号"),
          value: "baseMaterialNumber",
          fixedState: false,
          isShow: true,
          dataType: "text",
          selectOptionKey: "",
          selectOptionList: [],
          canEdit: false,
          width: 150,
        },
        {
          id: 4,
          name: this.$t("产品名称"),
          value: "baseMaterialName",
          fixedState: false,
          isShow: true,
          dataType: "text",
          selectOptionKey: "",
          selectOptionList: [],
          canEdit: false,
          width: 150,
        },
        {
          id: 2,
          name: this.$t("规格型号"),
          value: "specifications",
          fixedState: false,
          isShow: true,
          dataType: "textList",
          alwaysEditState: false,
          canEdit: false,
          width: 200,
        },
        {
          id: 2,
          name: this.$t("客户料号"),
          value: "baseCustomerMaterialNumber",
          fixedState: false,
          isShow: true,
          dataType: "text",
          alwaysEditState: false,
          canEdit: false,
          width: 120,
        },
        {
          id: 9,
          name: this.$t("本次收货数量"),
          value: "baseOutsourcingFinishedQuantity",
          fixedState: false,
          isShow: true,
          dataType: "number",
          canEdit: false,
          alwaysEditState: false,
          width: 120,
        },
        {
          id: 9,
          name: this.$t("收货日期"),
          value: "baseInwarehouseTime",
          fixedState: false,
          isShow: true,
          dataType: "dateTime",
          canEdit: false,
          alwaysEditState: false,
          width: 180,
        },
        {
          id: 11,
          name: this.$t("备注"),
          value: "remark",
          fixedState: false,
          isShow: true,
          dataType: "text",
          canEdit: false,
          alwaysEditState: false,
          width: 180,
        },
      ],
    };
  },
  async created() {
    this.getList();
  },
  methods: {
    // 多语言
    $t(value) {
      return value;
    },
    getList() {
      this.itemList = [];
      outsourcingtowarehouse_view({
        outsourcingtowarehouseId: this.routeQuery.outsourcingtowarehouseId,
      }).then((res) => {
        res.data.data.outsourcingDocNumber = res.data.data.baseOutsourcingDocNumber;
        try {
          res.data.data.specifications = JSON.parse(res.data.data.baseSpecgroupDesc);
        } catch (error) {}
        this.itemList.push(res.data.data);
        this.singleData = res.data.data;
      });
    },
    backHome() {
      this.$emit("backHome");
    },
  },
};
</script>
<style scoped>
::v-deep .el-descriptions-item__cell .el-descriptions-item__label .is-bordered-label {
  width: 120px !important;
}
.input {
  width: 100%;
}

.btnOne {
  background: #08a1b8;
  color: white;
}

.title {
  display: flex;
  position: relative;
  margin-bottom: 10px;
}

.title----font {
  color: rgb(8, 161, 184);
  position: relative;
  margin-left: 47%;
  font-size: 25px;
  font-weight: bold;
}

.title--button {
  position: absolute;
  margin-left: 1px;
  margin-top: 0.1%;
}
</style>
